/**
 * Mennegat Trading.
 *
 * @author Robuust
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import PhotoSwipeLightbox from 'photoswipe/lightbox'; // eslint-disable-line import/no-unresolved

/**
 * Gallery controller.
 */
export default class extends Controller {
  lightbox;

  /**
   * Initialize controller.
   */
  initialize() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.scope.controllerSelector,
      children: 'a',
      pswpModule: () => import('photoswipe'),
    });
  }

  /**
   * Init lightbox.
   */
  connect() {
    this.lightbox.init();
  }

  /**
   * Destroy lightbox.
   */
  disconnect() {
    this.lightbox.destroy();
  }
}
